const DOCTOR_CONSULTANCIES_KEY = "afrimed_doctor_consultancies_v1";

function safeParseJson(value) {
  if (value == null) return null;
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function scopedKey(baseKey, userId) {
  const uid = String(userId || "").trim();
  return uid ? `${baseKey}:${uid}` : baseKey;
}

function readArrayFromLocalStorage(keys = []) {
  if (typeof window === "undefined") return [];

  for (const key of keys) {
    if (!key) continue;
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) continue;
      const parsed = safeParseJson(raw);
      if (Array.isArray(parsed)) return parsed;
    } catch {
      // continue trying fallbacks
    }
  }

  return [];
}

export function readDoctorConsultancies(userId = "") {
  const uid = String(userId || "").trim();
  if (!uid) return [];

  const scoped = scopedKey(DOCTOR_CONSULTANCIES_KEY, uid);
  const rows = readArrayFromLocalStorage([scoped]);
  if (!Array.isArray(rows)) return [];

  // Safety gate: rows from this scoped key belong to this user.
  // Keep legacy rows that missed doctor_id and normalize them on read.
  return rows
    .map((row) => {
      const ownerId = String(row?.doctor_id || "").trim();
      if (ownerId && ownerId !== uid) return null;
      return { ...(row || {}), doctor_id: uid };
    })
    .filter(Boolean);
}

export function writeDoctorConsultancies(userId = "", rows = []) {
  if (typeof window === "undefined") return;
  const uid = String(userId || "").trim();
  if (!uid) return;
  const key = scopedKey(DOCTOR_CONSULTANCIES_KEY, uid);
  const safeRows = (Array.isArray(rows) ? rows : []).map((row) => ({
    ...(row || {}),
    doctor_id: uid,
  }));
  try {
    window.localStorage.setItem(key, JSON.stringify(safeRows));
  } catch {
    // ignore local preview write failures
  }
}
